import { useQuery } from "urql"

import type { ShipFromPreferenceItemInput, ShipFromPreferenceListQuery } from "@/graphql/codegen/graphql"
import { ShipFromPreferenceListDocument } from "@/graphql/codegen/graphql"

export interface ShipFromTransitTimeRowWithName extends ShipFromPreferenceItemInput {
  warehouseName?: string
}

interface UseGetShipFromTransitTimeResult {
  data: { rows: ShipFromTransitTimeRowWithName[] } | null
  isFetching: boolean
  refetch: () => void
}

export const useGetShipFromTransitTime = (locationId: string): UseGetShipFromTransitTimeResult => {
  const [result, refetch] = useQuery<ShipFromPreferenceListQuery>({
    query: ShipFromPreferenceListDocument,
    variables: {
      input: {
        filter: {
          shipToLocationId: locationId,
        },
      },
    },
  })

  const preferences =
    result.data?.shipFromPreference.list.__typename === "ShipFromPreferenceListSuccess"
      ? result.data.shipFromPreference.list.shipFromPreferences
      : []

  const rows: ShipFromTransitTimeRowWithName[] = preferences.map((pref) => {
    const warehouse = pref.shipFromWarehouse
    const externalSystemId = warehouse?.externalSystemId
    const locationDescription = warehouse?.location?.description

    const warehouseName =
      externalSystemId && locationDescription
        ? `${externalSystemId} ${locationDescription}`
        : externalSystemId || locationDescription

    return {
      shipFromWarehouseId: pref.shipFromWarehouseId,
      estimatedTransitDays: pref.estimatedTransitDays ?? null,
      isPreferred: pref.isPreferred ?? false,
      warehouseName,
    }
  })

  return {
    data: rows.length > 0 ? { rows } : null,
    isFetching: result.fetching,
    refetch: () => {
      refetch({ requestPolicy: "network-only" })
    },
  }
}
